/* eslint-disable no-script-url */
import React, { useEffect, useState } from "react";
import { Navbar, Nav, NavItem, NavLink } from "reactstrap";

const CategoryNavBar = (props) => {
	const {
		featuredCategories,
		clearFilters,
		push,
		persistSearch,
		setBoolean,
		setCategories,
		getInventory,
		categoriesFilter,
		clearAllParams,
		location,
	} = props;

	const [navClick, setNavClick] = useState(false);

	useEffect(() => {
		const fetchData = async () => {
			await getInventory({
				categories: categoriesFilter.join("|"),
				page_number: 1,
			}).then(() => {
				setNavClick(false);
			});
		};
		if (navClick) {
			fetchData();
		}
	}, [navClick]);

	const handleCategoryNav = (item) => {
		if (item.id === 0) {
			Promise.all([clearFilters(), push("/search")]);
		} else {
			Promise.all([
				clearAllParams(),
				clearFilters(),
				setCategories(item.id),
				setBoolean({ id: item.id, isChecked: true }),
				persistSearch({ page_number: "1" }, "page_number"),
				persistSearch({ categories: item.value }, "categories"),
				location.pathname.includes("/search") && setNavClick(true),
			]);
		}
	};
	return (
		<React.Fragment>
			<Navbar expand="md" className="cat-nav containercontainer" style={{ backgroundColor: "#fff" }}>
				{/* <Nav className="w-100">
					{featuredCategories.map((item) => (
						<NavItem key={item.id}>
							<NavLink
								className="pointer underline"
								style={{ textTransform: "uppercase", color: "#222222" }}
								onClick={() => handleCategoryNav(item)}
								id={item.id}>
								{item.value}
							</NavLink>
						</NavItem>
					))}
				</Nav> */}
			</Navbar>
		</React.Fragment>
	);
};

export default CategoryNavBar;
